/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState, ChangeEvent, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import '../scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import moEffectTrend, {
  changeType, changeValue,
} from './store/index';
import { DBox, DInput } from '../styled';
import {
  EntityHuman, CircleHuman, EntityCaiwu, CircleCaiwu,
  EntityFawu, CircleFawu, EntityIT, CircleIT,
  EntityXingzheng, CircleXingzheng,
} from '@styled/icon';
import MainTitle from '../../component/main-title';
import moEffectPdf from '../../store/index';
import moMenu from '@/page/effect/store/menu';

interface IProps {}
interface IState {}

const EffectTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, staffCount, overview,
    arr, tableTitle, tableList, maxStaff,
  } = moEffectTrend;
  const { staff_num_year_trend } = moEffectPdf;

  useEffect(() => {
    return () => {};
  }, []);

  const colors = (index: number, opacity: number) => {
    const arr = [
      `rgba(52, 63, 153, ${opacity})`,
      `rgba(248, 171, 66, ${opacity})`,
      `rgba(134, 212, 224, ${opacity})`,
      `rgba(250, 100, 1, ${opacity})`,
      `rgba(157, 162, 176, ${opacity})`,
      `rgba(133, 218, 50, ${opacity})`,
      `rgba(73, 121, 215, ${opacity})`,
      `rgba(112, 32, 130, ${opacity})`,
      `rgba(182, 100, 210, ${opacity})`,
      `rgba(0, 195, 137, ${opacity})`,
      `rgba(255, 82, 82, ${opacity})`,
      `rgba(204, 204, 204, ${opacity})`,
    ];
    return arr[index];
  };

  const humans = (name: string, count: number, idx: number) => {
    const doms: any[] = [];
    const length = (count / maxStaff) * 20;
    for (let i = 1; i <= length; i += 1) {
      if (name.includes('人力资源')) {
        doms.push(<EntityHuman color={colors(idx, 1)} height={20} width={20} key={i} />);
      } else if (name.includes('财务')) {
        doms.push(<EntityCaiwu color={colors(idx, 1)} height={16} width={16} key={i} />);
      } else if (name.includes('IT')) {
        doms.push(<EntityIT color={colors(idx, 1)} height={16} width={16} key={i} />);
      } else if (name.includes('行政')) {
        doms.push(<EntityXingzheng color={colors(idx, 1)} height={16} width={16} key={i} />);
      } else if (name.includes('法务')) {
        doms.push(<EntityFawu color={colors(idx, 1)} height={16} width={16} key={i} />);
      }
    }
    return doms;
  };

  const locateValue = (value: any) => {
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value <= 0) return '-';
    return Number(value).toLocaleString();
  };

  return (
    <section id="effect16" className="effect-10 box-111 human-common-pdf">
      <MainTitle
        title='支持效能时间趋势'
        subtitle={moMenu.industryName}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />

      <section className="content-151 content-153">
        {!empty ? (
          <section className="content-255">
            <section className="line-301"
              style={{ paddingLeft: '60px' }}>
              <span>全职员工数</span>
              <DBox>
                <DInput value={staff_num_year_trend} disabled={true}
                  placeholder="请输入" />
                <b>人</b>
              </DBox>
            </section>
            <p className="line-302"
              style={{ paddingLeft: '60px' }}>
              系统将依据调研到的支持效能的比值，换算成该人员规模下，建议的各支持部门的人员数量配置。
            </p>

            <section className="content-6699">
              <section className="content-66990">
                {arr.map((item: any, index: number) => (
                  <section key={index} className="content-30">
                    <strong>{item.category}</strong>
                    <section className="content-31">
                      {item.data?.map((child: any, idx: number) => (
                        <section key={idx} className="content-33">
                          <section className="content-3301 content-3303 content-33011">
                            {idx !== 0 ? <p className="place-3301" /> : null}
                            <p className="line-3301">
                              <span className="digit-11">{child.label}年&nbsp;</span>
                              <span className="digit-11">&nbsp;{locateValue(child.count)}&nbsp;</span>
                              {child.count > 0 ? (
                                <span>人</span>
                              ) : (
                                <span className="digit-11">-</span>
                              )}
                            </p>
                          </section>
                          <section className="content-3301 content-3305">
                            {idx !== 0 ? <p className="place-3301" /> : null}
                            <section className="line-3302">
                              <p className={[
                                'icon-111',
                                !item.category.includes('人力资源') ? 'icon-115' : '',
                              ].join(' ')}>
                                {humans(item.category, child.count, idx)}
                              </p>
                              {!Number.isInteger(child.count / maxStaff * 20) ? (
                                <p className="icon-111">
                                  {item.category.includes('人力资源') ? (
                                    <CircleHuman color={colors(idx, 1)} height={20} width={20} />
                                  ) : null}
                                  {item.category.includes('财务') ? (
                                    <CircleCaiwu color={colors(idx, 1)} height={16} width={16} />
                                  ) : null}
                                  {item.category.includes('法务') ? (
                                    <CircleFawu color={colors(idx, 1)} height={16} width={16} />
                                  ) : null}
                                  {item.category.includes('IT') ? (
                                    <CircleIT color={colors(idx, 1)} height={16} width={16} />
                                  ) : null}
                                  {item.category.includes('行政') ? (
                                    <CircleXingzheng color={colors(idx, 1)} height={16} width={16} />
                                  ) : null}
                                </p>
                              ) : null}
                            </section>
                          </section>
                        </section>
                      ))}
                    </section>
                  </section>
                ))}
              </section>
            </section>
          </section>
        ) : (<Empty />)}
      </section>

      {!isEmpty(overview) && <section className="chart-detail industry-detail">
        <section>注：</section>
        {
          overview?.map((res: any, r: any) => {
            return <section className='item' key={`${r}`}>
              <b />
              <p >
                {res.map((ele: any, e: any) => {
                  return <span className={ele.mark} key={`${e}l`}>
                    {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 1)) : ele.value}
                  </span>;
                })}
              </p>
            </section>;
          })}
      </section>}
    </section>
  );
};

export default observer(EffectTrend);
